import { render } from "./ic-check.vue?vue&type=template&id=006b157b"
import script from "./ic-check.vue?vue&type=script&lang=js"
export * from "./ic-check.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__